import Styled from '@/components/pages/signup/components';
import { PRIVACY_NOTICE, SAAS_SERVICES_AGREEMENT } from '@/constants/routes';
import { FRONT_LEGAL_NAME } from '@/constants/strings';


const TermsAndPrivacyNotice = () => {
  return (
    <Styled.LegalNotice>
      <p className="legalText">
        By clicking &rsquo;&rsquo;Submit&rsquo;&rsquo;, I acknowledge I have read and agreed to {FRONT_LEGAL_NAME}&rsquo;s{' '}
        <a href={SAAS_SERVICES_AGREEMENT} target="_blank">
          Terms
        </a>{' '}
        and{' '}
        <a href={PRIVACY_NOTICE} target="_blank">
          Privacy Notice
        </a>
        .
      </p><br />
    </Styled.LegalNotice>
  );
};

export default TermsAndPrivacyNotice;
